<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    floating
    persistent
    mobile-breakpoint="1367"
    width="288"
  >
    <v-layout column>
      <LogoSection
        :logo-image="logoImage"
      />
      <v-divider />
      <DrawerLinks :links="links" />
      <ModuleLinks :modules="modules" />
    </v-layout>
    <v-divider class="mt-6" />
  </v-navigation-drawer>
</template>

<script>

import { mapMutations, mapState, mapGetters } from "vuex";
import {getLogoUrl} from "@/utils/getLogo";
import LogoSection from "@/components/core/Drawer/LogoSection.vue";
import DrawerLinks from "@/components/core/Drawer/DrawerLinks.vue";
import ModuleLinks from "@/components/core/Drawer/ModuleLinks.vue";

export default {
  components: {DrawerLinks, ModuleLinks, LogoSection},
  data() {
    // console.log('linkgs', DRAWER_LINKS(this.$t))
    return {
      logoLight: this.$ls.get('config').logo_light_theme,
      logoDark: this.$ls.get('config').logo_dark_theme,
      links: [
        {
          to: "/dashboard",
          icon: "icn24_category",
          text: this.$t("drawer.dashboard")
        },
        {
          to: "/whitelabels",
          icon: 'icn24_buildings',
          text: this.$t("drawer.whiteLabel")
        },
        {
          to: "/users",
          icon: 'icn24_users',
          text: this.$t("drawer.users")
        },
        {
          to: "/invoices",
          icon: 'icn24_receipt',
          text: this.$t("drawer.billing")
        },
        {
          to: "/withdrawals",
          icon: 'icn24_upload',
          text: this.$t("drawer.withdrawals")
        },
        {
          to: "/transactions",
          icon: 'icn24_swap_alt',
          text: this.$t("drawer.transactions")
        }
      ],
      responsive: false
    };
  },
  computed: {
    ...mapState("app", ["image", "color", "pendingRequests"]),
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    logo() {
      return this.$vuetify.theme.dark ? this.logoDark : this.logoLight
    },
    logoImage() {
      const image = getLogoUrl(this.getWhiteLabel || {}, this.$vuetify.theme.dark || false) || this.logo;
      return this.getWhiteLabel === undefined ? null : image;
    },
    modules() {
      if (!this.getWhiteLabel) return null;

      const modules = new Map();

      this.getWhiteLabel.modules.forEach(module => {
        const { menu } = module.public_config;
        if (menu && menu.type === 'admin' && menu.position === 'left') {
          menu.config.forEach(item => {
            const newItem = { ...item, submenu: menu.submenu || item.submenu };
            modules.set(item.path, newItem);
          });
        }
      });

      return Array.from(modules.values());
    },

    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  unmounted() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", [
      "setDrawer",
      "toggleDrawer",
      "setPendingRequests",
      "setShowChat"
    ]),
    onResponsiveInverted() {
      this.responsive = window.innerWidth < 1367;
    },
  }
};
</script>

<style lang="scss">
#app-drawer {
  .theme--light {
    color: #96a2ae!important;
    svg {
      fill: #96a2ae!important;
    }
  }
  .theme--dark {
    svg {
      fill: #fff!important;
    }
  }
  .v-image__image--contain {
    top: 16px;
    height: 60%;
  }

  .v-list-item {
    max-height: 52px;
  }

  div.v-responsive.v-image > div.v-responsive__content {
    overflow-y: auto;
  }
  .v-list-item__icon {
    margin-right: 15px;
    margin-top: 12px;
    margin-bottom: 12px;
  }
}
</style>
